const initialState = {
  resultsCurationProductsList: [],
  resultsCurationProduct: {},
  resultsCurationFeaturedList: [],
  resultsCurationFeatured: {},
  resultsCurationFeaturedAdd: {},
  resultsCurationFeaturedPatch: {},
  resultsCurationFeaturedDelete: {},
  resultsCurationExcludedList: [],
  resultsCurationExcluded: {},
  resultsCurationExcludedAdd: {},
  resultsCurationExcludedDelete: {},
  resultsCurationExcludedAddAll: {},
  resultsCurationExcludedDeleteAll: {},
  resultsCurationFeaturedAddAll: {},
  resultsCurationFeaturedDeleteAll: {},
  resultsCurationManagerActivitiesList: {},
  resultsCurationManagerExcludedActivitiesList: {},
  resultsCurationManagerExcludedActivitiesAdd: {},
  resultsCurationManagerExcludedActivitiesAll: {}
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_CURATION_PRODUCTS_RESPONSE_GET":
      newState.resultsCurationProductsList = action.value;
      break;

    case "CURATION_PRODUCT_RESPONSE_GET":
      newState.resultsCurationProduct = action.value;
      break;

    case "LIST_CURATION_FEATURED_ACTIVITIES_RESPONSE_GET":
      newState.resultsCurationFeaturedList = action.value;
      break;

    case "CURATION_FEATURED_ACTIVITY_RESPONSE_GET":
      newState.resultsCurationFeatured = action.value;
      break;

    case "CURATION_FEATURED_ACTIVITY_RESPONSE_ADD":
      newState.resultsCurationFeaturedAdd = action.value;
      break;

    case "CURATION_FEATURED_ACTIVITY_RESPONSE_UPDATE":
      newState.resultsCurationFeaturedPatch = action.value;
      break;

    case "CURATION_FEATURED_ACTIVITY_RESPONSE_DELETE":
      newState.resultsCurationFeaturedDelete = action.value;
      break;

    case "LIST_CURATION_EXCLUDED_ACTIVITIES_RESPONSE_GET":
      newState.resultsCurationExcludedList = action.value;
      break;

    case "CURATION_EXCLUDED_ACTIVITY_RESPONSE_GET":
      newState.resultsCurationExcluded = action.value;
      break;

    case "CURATION_EXCLUDED_ACTIVITY_RESPONSE_ADD":
      newState.resultsCurationExcludedAdd = action.value;
      break;

    case "CURATION_EXCLUDED_ACTIVITY_RESPONSE_DELETE":
      newState.resultsCurationExcludedDelete = action.value;
      break;

    case "CURATION_EXCLUDED_ACTIVITIES_ALL_RESPONSE_ADD":
      newState.resultsCurationExcludedAddAll = action.value;
      break;

    case "CURATION_EXCLUDED_ACTIVITIES_ALL_RESPONSE_DELETE":
      newState.resultsCurationExcludedDeleteAll = action.value;
      break;

    case "CURATION_FEATURED_ACTIVITIES_ALL_RESPONSE_ADD":
      newState.resultsCurationFeaturedAddAll = action.value;
      break;

    case "CURATION_FEATURED_ACTIVITIES_ALL_RESPONSE_DELETE":
      newState.resultsCurationFeaturedDeleteAll = action.value;
      break;

    case "LIST_CURATION_MANAGER_ACTIVITIES_RESPONSE":
      newState.resultsCurationManagerActivitiesList = action.value;
      break;
    case "LIST_CURATION_MANAGER_EXCLUSION_ACTIVITIES_RESPONSE":
      newState.resultsCurationManagerExcludedActivitiesList = action.value;
      break;
    case "MANAGER_EXCLUSION_ACTIVITIES_RESPONSE_UPDATE":
      newState.resultsCurationManagerExcludedActivitiesAdd = action.value;
      break;
    case "MANAGER_EXCLUSION_ACTIVITIES_ALL_RESPONSE":
      newState.resultsCurationManagerExcludedActivitiesAll = action.value;
      break;

    case "RESET_CURATION_RESPONSES":
      newState.resultsCurationFeaturedAdd = {};
      newState.resultsCurationFeaturedPatch = {};
      newState.resultsCurationFeaturedDelete = {};
      newState.resultsCurationExcludedAdd = {};
      newState.resultsCurationExcludedDelete = {};
      newState.resultsCurationExcludedAddAll = {};
      newState.resultsCurationExcludedDeleteAll = {};
      newState.resultsCurationFeaturedAddAll = {};
      newState.resultsCurationFeaturedDeleteAll = {};
      newState.resultsCurationManagerActivitiesList = {};
      newState.resultsCurationManagerExcludedActivitiesList = {};
      newState.resultsCurationManagerExcludedActivitiesAdd = {};
      newState.resultsCurationManagerExcludedActivitiesAll = {};
      break;

    default:
      break;
  }

  return newState;
};

export default reducer;
